<template>
    <div  class="uk-padding" style="background: black;  color: rgb(197,179,88); border-top: rgb(197,179,88);">
        <div class="uk-container uk-container-large">
            <div class="uk-child-width-1-5@m" uk-grid>
                <div>
                    <h3 class="uk-heading-bullet" style="color: silver">Contact Information</h3>
                    <p>
                        <span class="uk-margin-small-right" uk-icon="receiver" style="color: silver"></span>
                        <!--<span class="uk-text-small" style="font-size: 14px; color: rgba(197, 179, 88, 0.8);">
                            1 345-746-9272 (345-74MYCPA)
                        </span>-->
                        <a href="tel:1345-746-9272" style="font-size: 14px; color: rgba(197, 179, 88, 0.8);"> 1345-746-9272 (345-74MYCPA)</a>
                    </p>
                    <div uk-grid>
                        <div class="uk-width-auto">
                            <!--<span class="uk-margin-small-right" uk-icon="location" style="color: silver"></span>-->
                        </div>
                        <div class="uk-width-expand uk-text-small uk-padding-remove-left" style="font-size: 14px; color: rgba(197, 179, 88, 0.8);">
                          3 rd Floor, Amerigo House, Elizabethan Square, <br> George Town, <br>
                          Box 31614, SMB, KY1-1207, <br> Grand Cayman, Cayman Islands <br>

                        </div>
                    </div>
                </div>
                <div>
                    <h3 class="uk-heading-bullet" style="color: silver">Industries</h3>
                    <ul class="uk-list">
                        <li><router-link to="/public-sector-financial-services">Public Sector</router-link></li>
                        <li><router-link to="/private-business-and-individual-financial-services">Private Business and Individuals</router-link></li>
                        <li><router-link to="/charities-and-non-profit-financial-services">Charities and Non-Profits</router-link></li>
                    </ul>
                </div>
                <div>
                    <a class="uk-navbar-item uk-logo uk-text-center" href="#">
                        <img src="../../../public/fincor_lion.png" class="logoStyle uk-align-center" alt="">
                    </a>
                </div>
                <div>
                    <h3 class="uk-heading-bullet" style="color: silver">Services</h3>
                    <ul class="uk-list">
                        <li><router-link to="/accountant-reviews-financial-services">Accountant Reviews</router-link></li>
                        <li><router-link to="/financial-advisory-services">Financial Advisory</router-link></li>

                        <li><router-link to="/financial-management-services">Financial Management</router-link></li>
                        <li><router-link to="/financial-reporting-services">Financial Reporting</router-link></li>
                    </ul>
                </div>
                <div>
                    <h3 class="uk-heading-bullet" style="color: silver">Social Links</h3>
                    <div class="socialLink">

                        <a href="https://www.facebook.com/fincorcayman/?hc_ref=SEARCH&amp;fref=nf" target="_blank" class="uk-icon-button  uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="https://www.instagram.com/fincor_cayman/" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="instagram"></a>

                       <!-- <a href="" class="uk-icon-button uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-margin-small-right" uk-icon="whatsapp"></a>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footer"
    }
</script>

<style scoped>
    .logoStyle{
        max-height: 200px;
        max-width: 200px;
        width: auto;
        height: auto;
    }
    .uk-list li a{
        font-size: 14px;
        color: rgba(197, 179, 88, 0.8);
    }
    .socialLink a{
        background: rgba(197, 179, 88, 0.7);
        color: #333;
    }
</style>